export default class PlayerImage extends Phaser.GameObjects.Image {
    constructor(scene: Phaser.Scene, x: number, y: number, key: string, frame?: string) {
        super(scene, x, y, key, frame);
        this.setOrigin(0.5, 0.5);
        // this.setScale(0.2, 0.2);
        this.setDisplaySize(70, 70);
        this.setDepth(40);
        scene.add.existing(this);
    }
}